'use client'
// CurrencyPrice — minimal client wrapper to display a EUR amount in the user's
// preferred currency. Used in server-rendered pages where the useCurrency() hook
// cannot be called directly. On mount it reads the currency preference from
// localStorage and converts the price, so the initial render always shows EUR
// (matching server HTML) and updates immediately after hydration.
import { useCurrency } from '@/lib/currency'

export default function CurrencyPrice({ amount, className }) {
  const { formatDealPrice } = useCurrency()
  const { primary } = formatDealPrice(amount)
  if (className) return <span className={className}>{primary}</span>
  return <>{primary}</>
}
